import {NgModule, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'ProductPipe',
    standalone: false
})
export class ProductPipe implements PipeTransform {
    public transform(items, filter, data) {

        if (!filter) return items;
        if (!data) {
            data = null;
        }
        return (items || []).filter((item) => item[filter] == data );

    }
}

@NgModule({
    declarations: [ProductPipe],
    exports: [ProductPipe],
    providers: [ProductPipe]
})
export class ProductPipeModule {}
